import {prepareRequest} from "@/services";
import {HUB_URL} from "@/services/url";

async function getDomainSettings(domain) {
    let response = await prepareRequest(null,{
        method: "GET",
        url: `${HUB_URL}/CompanyConfigs/Get/${domain}`
    }, true);
    return response;
}
export {getDomainSettings};
